import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { Dispatch } from './Dispatch';
import { Field } from './Field';

// G-OD4: /ezy/service/today = Việc hôm nay (Mint-OpsField-Phone).
// G-OD1: Ezy › Dịch vụ › Điều phối hiện trường (Mint-OpsDispatch) — /ezy/service/dispatch. Không thêm mục menu riêng (vào từ Service Hub).
const dispatch: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/service/dispatch', component: Dispatch }), createRoute({ getParentRoute: () => parent, path: '/service/today', component: Field })],
};
export default dispatch;
